module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_c('ui-title', {
    attrs: {
      "icon": "assignment_ind"
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('div', {
    class: {
      'flip-container': true, 'flipped': _vm.success
    }
  }, [_c('div', {
    staticClass: "flipper"
  }, [_c('div', {
    staticClass: "front"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendForm($event)
      }
    }
  }, [_c('ui-field-group', {
    attrs: {
      "invalid": _vm.name_error,
      "value": _vm.name
    }
  }, [_c('ui-text', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "name": "name",
      "value": _vm.newsletter.name
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        _vm.name = $event
      }
    }
  }), _vm._v(" "), _c('ui-label', [_vm._v("Nome")])], 1), _vm._v(" "), _c('ui-field-group', {
    attrs: {
      "invalid": _vm.email_error,
      "value": _vm.email
    }
  }, [_c('ui-text', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "value": _vm.newsletter.email
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        _vm.email = $event
      }
    }
  }), _vm._v(" "), _c('ui-label', [_vm._v("E-mail")])], 1), _vm._v(" "), _c('div', {
    staticClass: "newsletter-submit-box"
  }, [_c('ui-button', {
    attrs: {
      "with-icon": "send",
      "colored": "",
      "raised": "",
      "disabled": _vm.disabled
    }
  }, [_vm._v("Enviar")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back"
  }, [_c('div', {
    staticClass: "message-box"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "icon": "chevron_left",
      "type": "button",
      "primary": "",
      "fab": "",
      "big-icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cleanForm($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('ui-button', {
    attrs: {
      "icon": "add",
      "type": "button",
      "fab": "",
      "big-icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.notificate($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77bdbd35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Register.vue
// module id = 277
// module chunks = 2